import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { get } from 'lodash';
import { nocModeSelector } from '@store/noc/base/selectors';
// eslint-disable-next-line import/namespace
import { dataSelector as filtersDataSelector } from '@store/noc/filtersData/selectors';
import { dataSelector as trendsDataSelector } from '@store/noc/trendsData/selectors';
import { NOC_MODE_TRENDS } from '@utils/constants';
import { TimeTablet } from '../../styled';
import { LiveModeMarker } from '@src/components/common/Utils/Markers';
import { getEndTimeOfIntervalAnnotation } from '@src/utils/common';
// eslint-disable-next-line react/display-name
export default (props) => {
  const mode = useSelector(nocModeSelector);
  let nocFilters;
  let timeStamp;
  if (mode === NOC_MODE_TRENDS) {
    nocFilters = useSelector(trendsDataSelector);
    const endTime = getEndTimeOfIntervalAnnotation(get(nocFilters, 'annotations', []), [
      'realtimeIntervalAlignment',
      'intervalAlignment',
    ]);
    timeStamp = endTime ? endTime : get(nocFilters, ['data', 0, 'timestamp'], '');
  } else {
    nocFilters = useSelector(filtersDataSelector);
    timeStamp = get(nocFilters, 'timestamp', '');
  }

  return (
    <TimeTablet>
      <LiveModeMarker />
      {timeStamp === '' ? (
        <span className="loading-time">
          {'Live : '} <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      ) : (
        `Live : ${moment(timeStamp).format('DD  MMM, YYYY HH:mm:ss')}`
      )}
    </TimeTablet>
  );
};
